/**
 * 担当者情報の共通バリデーションライブラリ
 * 会社情報の担当者および請求先担当者のバリデーションで共通使用
 */

import { validateStringField, validateEmail, validatePhone, validateKana } from './common_validation';

/**
 * 担当者名のバリデーション
 */
export const validateContactName = (value: string | undefined | null, required = true): string | undefined => {
  return validateStringField(value, '担当者名', { required });
};

/**
 * 担当者名（カナ）のバリデーション
 */
export const validateContactNameKana = (value: string | undefined | null, required = true): string | undefined => {
  return validateKana(value, '担当者名（カナ）', required);
};

/**
 * 担当者メールアドレスのバリデーション
 */
export const validateContactEmail = (value: string | undefined | null, required = true): string | undefined => {
  return validateEmail(value, '担当者メールアドレス', required);
};

/**
 * 担当者電話番号のバリデーション
 */
export const validateContactTel = (value: string | undefined | null, required = true): string | undefined => {
  return validatePhone(value, '担当者電話番号', required);
};

/**
 * 担当者所属部署のバリデーション
 */
export const validateContactDepartment = (
  value: string | undefined | null,
  required = false
): string | undefined => {
  return validateStringField(value, '担当者所属部署', { required });
};
